import {defineMessages, MessageDescriptor} from 'react-intl'

export const SCORES = [1, 2, 3, 4, 5, 6, 7] as const

export type SurveyBannerStatus = 'idle' | 'submitting' | 'submitted'

export const SURVEY_MESSAGES = defineMessages({
  '4d3c3400': {
    id: 'trustSurveyStatement.4d3c3400',
    defaultMessage:
      '"Overall, I\'d feel comfortable relying on Vio to book a hotel."'
  },
  '4d3c3401': {
    id: 'trustSurveyStatement.4d3c3401',
    defaultMessage: '"Vio seems to search a lot of booking sites for me."'
  },
  '4d3c3402': {
    id: 'trustSurveyStatement.4d3c3402',
    defaultMessage: '"The hotel guest ratings on Vio look genuine."'
  },
  '4d3c3403': {
    id: 'trustSurveyStatement.4d3c3403',
    defaultMessage:
      '"Vio feels like it\'s built to help travelers, not just to get bookings."'
  },
  '4d3c3404': {
    id: 'trustSurveyStatement.4d3c3404',
    defaultMessage:
      '"Vio seems to keep its prices up to date with the other sites."'
  },
  '4d3c3405': {
    id: 'trustSurveyStatement.4d3c3405',
    defaultMessage: '"The savings Vio shows look realistic."'
  },
  '4d3c3406': {
    id: 'trustSurveyStatement.4d3c3406',
    defaultMessage:
      '"The deals Vio highlights seem chosen with my interests in mind."'
  },
  '4d3c3407': {
    id: 'trustSurveyStatement.4d3c3407',
    defaultMessage:
      '"Vio looks like it could save me money compared to searching elsewhere."'
  },
  '4d3c3408': {
    id: 'trustSurveyStatement.4d3c3408',
    defaultMessage:
      '"Vio seems able to get me deals I wouldn\'t find on other booking sites."'
  },
  '4d3c3409': {
    id: 'trustSurveyStatement.4d3c3409',
    defaultMessage:
      '"Vio seems honest about when it does and doesn\'t beat the other booking sites."'
  },
  '4d3c3410': {
    id: 'trustSurveyStatement.4d3c3410',
    defaultMessage: '"Vio feels more on my side than other booking sites."'
  }
})

export type SurveyStatementKey = keyof typeof SURVEY_MESSAGES

export interface SurveyQuestion {
  /** Stable `4d3c34xx` id sent with tracking events. */
  questionId: SurveyStatementKey
  statement: MessageDescriptor
}
